import React, { useState, useEffect } from 'react';
import { getFromDB } from "../../firebase";
import './Stats.css'
import LeagueStats from './LeagueStats';
import NationalitiesStats from './NationalitiesStats';
import LicencesStats from './LicencesStats';
import JflStats from './JflStats';
import HeightStats from './HeightStats';
import AgeStats from './AgeStats';
import HeightPlayersStats from './HeightPlayersStats';
import AgePlayersStats from './AgePlayersStats';
import {Cache} from '../utils/Cache'

function Stats() {

  const [selectedSection, setSelectedSection] = useState(null);
  const [teams, setTeams] = useState([])
  const [errorMsg, setErrorMsg] = useState('')

  const showMenu = () => setSelectedSection(null);
  const goSection = (section) => setSelectedSection(section);

  useEffect(() => {
    const getTeamsFromFirestore = async () => {
      const teamsStored = Cache.getWithExpiry(Cache.keyTeams)
      if (teamsStored === null) {
        try {
          const queryData = {table: 'teams', conditions: {field: 'otherCategory', operator: '==', value: false}}
          const dataResults = await getFromDB(queryData)
          setTeams(dataResults);
          Cache.setWithExpiry(Cache.keyTeams, dataResults)
        } catch (error) {
          console.error('Error al obtener los datos de los equipos:', error);
          setErrorMsg('Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde')
        }
      } else {
        setTeams(teamsStored)
      }
    };

    getTeamsFromFirestore();
  }, []); 

  const titleSection = [
    { id: 'section-ligas', title: 'Ligas de procedencia' },
    { id: 'section-nacionalidades', title: 'Nacionalidades de jugadores' },
    { id: 'section-licencias', title: 'Jugadores por licencia' },
    { id: 'section-jfls', title: 'Número de JFLs por equipo' },
    { id: 'section-altura', title: 'Altura media de jugadores por equipo' },
    { id: 'section-edad', title: 'Edad media de jugadores por equipo' },
    { id: 'section-altura-jugadores', title: 'Altura de jugadores' },
    { id: 'section-edad-jugadores', title: 'Edad de jugadores' }
  ]

  const showSection = (section) => {
    const title = titleSection.find(item => item.id === section);
    if (!title) return null;
    
    return <section id={section} className="section">
    <button className="back-button" onClick={showMenu}>⬆ Volver al menú</button>
    <h2>{title.title}</h2>
    {section === 'section-ligas' && teams.length > 0 && (<div className="league-stats"> {<LeagueStats teams={teams}/>} </div>)}
    {section === 'section-nacionalidades' && teams.length > 0 && (<div className="nationalities-stats"> {<NationalitiesStats teams={teams}/>} </div>)}
    {section === 'section-licencias' && teams.length > 0 && (<div className="licences-stats"> {<LicencesStats teams={teams}/>} </div>)}
    {section === 'section-jfls' && teams.length > 0 && (<div className="jfl-stats"> {<JflStats teams={teams}/>} </div>)}
    {section === 'section-altura' && teams.length > 0 && (<div className="height-stats"> {<HeightStats teams={teams}/>} </div>)}
    {section === 'section-edad' && teams.length > 0 && (<div className="age-stats"> {<AgeStats teams={teams}/>} </div>)}
    {section === 'section-altura-jugadores' && teams.length > 0 && (<div className="height-players-stats"> {<HeightPlayersStats teams={teams}/>} </div>)}
    {section === 'section-edad-jugadores' && teams.length > 0 && (<div className="age-players-stats"> {<AgePlayersStats teams={teams}/>} </div>)}
  </section>
  }
  return (
    <div className="stats-container">
      {!selectedSection ? (
      <div className="menu-screen">
        <h2 className="title-stats">Datos estadísticos</h2>
        <nav className="menu-stats">
          <h3>Globales</h3>
          <ul>
              <li onClick={() => goSection('section-ligas')}>Ligas de procedencia</li>
              <li onClick={() => goSection('section-nacionalidades')}>Nacionalidades jugadores</li>
              <li onClick={() => goSection('section-licencias')}>Jugadores por licencia</li>
          </ul>
          <h3>Por equipo</h3>
          <ul>
            <li onClick={() => goSection('section-jfls')}>Número de JFLs</li>
            <li onClick={() => goSection('section-altura')}>Altura media de jugadores</li>
            <li onClick={() => goSection('section-edad')}>Edad media de jugadores</li>
          </ul>
          <h3>Por jugador</h3>
          <ul>
            <li onClick={() => goSection('section-altura-jugadores')}>Altura</li>
            <li onClick={() => goSection('section-edad-jugadores')}>Edad</li>
          </ul>
        </nav>
      </div>
      ) : (
        <div className="section-screen">
          {showSection(selectedSection)}
      </div>
      )
    }
    {errorMsg}
    </div>
  )
}

export default Stats